<template>
  <div id="app">
    <notifications-component/>
    <router-view/>
  </div>
</template>

<style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/_custom/theme-shadow-portal.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>

import Notifications from '@/components/partials/Notifications'

export default {
    name: 'app',
    components: {
        'notifications-component': Notifications
    },
    // metaInfo: {
    //     title: 'App',
    //     titleTemplate: '%s'
    // },
    created: function () {
        const self = this
        this.$axios.get('/portal/office/1')
            .then(function (res) {
                self.$store.commit('setOffice', res.data)
                document.title = self.$store.state.office.name
                self.applyThemeColor(res.data.portal_primary_color)
            })
            .catch(function () {
                // this.beepsLoading = false;
            })
    },
    methods: {
        parseColor (color) {
            const value = String(color || '').trim()
            let m = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
            if (m) return [Number(m[1]), Number(m[2]), Number(m[3])]
            m = value.match(/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/)
            if (m) {
                let c = m[1]
                if (c.length === 3) c = c.split('').map(ch => ch + ch).join('')
                const num = parseInt(c, 16)
                return [(num >> 16) & 255, (num >> 8) & 255, num & 255]
            }
            return null
        },
        luminance (rgb) {
            const a = rgb.map(v => {
                v /= 255
                return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
            })
            return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]
        },
        contrast (a, b) {
            const la = this.luminance(a)
            const lb = this.luminance(b)
            return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05)
        },
        scale (rgb, factor) {
            return rgb.map(v => Math.max(0, Math.min(255, Math.round(v * factor))))
        },
        // Oscurece el color hasta que sea legible sobre fondo blanco (contraste >= 4.5)
        readableOnWhite (rgb) {
            let c = rgb.slice()
            let guard = 0
            while (this.contrast(c, [255, 255, 255]) < 4.5 && guard < 40) {
                c = this.scale(c, 0.92)
                guard++
            }
            return c
        },
        applyThemeColor (rawColor) {
            const rgb = this.parseColor(rawColor)
            if (!rgb) return

            const toRgb = c => `rgb(${c[0]}, ${c[1]}, ${c[2]})`
            const toRgba = (c, alpha) => `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`

            // Paleta derivada y armónica a partir del color base
            const base = rgb
            const hover = this.scale(base, 0.9)
            const active = this.scale(base, 0.8)
            // Sesga hacia texto blanco; usa oscuro solo en colores claros
            const textOnBase = this.luminance(base) > 0.6 ? '#2b2b3c' : '#fff'
            const accent = this.readableOnWhite(base)

            // Tinte sutil: mezcla del color con blanco (amount = proporción de color)
            const tint = (c, amount) => c.map(v => Math.round(v * amount + 255 * (1 - amount)))
            const bodyBg = tint(base, 0.05)
            const navBg = tint(base, 0.15)

            const color = toRgb(base)
            const css = `
                body {
                    background-color: ${toRgb(bodyBg)} !important;
                }
                .layout-navbar,
                .layout-navbar.bg-light,
                .layout-navbar.bg-navbar-theme {
                    background-color: ${toRgb(navBg)} !important;
                }
                .layout-navbar .navbar-nav .nav-link {
                    color: #404552 !important;
                }
                .layout-navbar .navbar-nav .nav-link:hover,
                .layout-navbar .navbar-nav .nav-link:focus,
                .layout-navbar .navbar-nav .nav-link.active,
                .layout-navbar .navbar-nav .show > .nav-link {
                    color: ${toRgb(accent)} !important;
                }
                .layout-navbar .navbar-brand {
                    color: #2b2b3c !important;
                }
                .btn-primary {
                    background-color: ${color} !important;
                    border-color: ${color} !important;
                    color: ${textOnBase} !important;
                }
                .btn-primary:hover {
                    background-color: ${toRgb(hover)} !important;
                    border-color: ${toRgb(hover)} !important;
                    color: ${textOnBase} !important;
                }
                .btn-primary:focus, .btn-primary.focus {
                    box-shadow: 0 0 0 0.2rem ${toRgba(base, 0.4)} !important;
                }
                .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
                    background-color: ${toRgb(active)} !important;
                    border-color: ${toRgb(active)} !important;
                    color: ${textOnBase} !important;
                }
                .btn-outline-primary {
                    color: ${toRgb(accent)} !important;
                    border-color: ${color} !important;
                }
                .btn-outline-primary:hover,
                .btn-outline-primary:active,
                .btn-outline-primary.active,
                .btn-group > .btn-outline-primary.active {
                    background-color: ${color} !important;
                    border-color: ${color} !important;
                    color: ${textOnBase} !important;
                }
                .btn-outline-primary:focus, .btn-outline-primary.focus {
                    box-shadow: 0 0 0 0.2rem ${toRgba(base, 0.4)} !important;
                }
                .btn-primary:not(:disabled):not(.disabled):active:focus,
                .btn-outline-primary:not(:disabled):not(.disabled):active:focus {
                    box-shadow: 0 0 0 0.2rem ${toRgba(base, 0.4)} !important;
                }
                .bg-primary {
                    background-color: ${color} !important;
                }
                .bg-primary, .bg-primary * {
                    color: ${textOnBase} !important;
                }
                .flatpickr-day.selected, .flatpickr-day.selected:hover,
                .flatpickr-day.startRange, .flatpickr-day.endRange {
                    background: ${color} !important;
                    border-color: ${color} !important;
                    color: ${textOnBase} !important;
                }
                .flatpickr-day.today {
                    border-color: ${toRgb(accent)} !important;
                }
                .flatpickr-day.today:hover {
                    background: ${toRgb(accent)} !important;
                    color: #fff !important;
                }
                .layout-content a:not(.btn),
                .authentication-inner a:not(.btn),
                .nav-link.active,
                .text-primary {
                    color: ${toRgb(accent)} !important;
                }
                .custom-control-input:checked ~ .custom-control-label::before {
                    background-color: ${color} !important;
                    border-color: ${color} !important;
                }
                .page-item.active .page-link {
                    background-color: ${color} !important;
                    border-color: ${color} !important;
                    color: ${textOnBase} !important;
                }
            `
            let style = document.getElementById('portal-theme-color')
            if (!style) {
                style = document.createElement('style')
                style.id = 'portal-theme-color'
                document.head.appendChild(style)
            }
            style.innerHTML = css
        }
    },
    updated () {
    // Remove loading state
        setTimeout(() => document.body.classList.remove('app-loading'), 1)
    }
}
</script>
